module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Sport Aluminum + Fog Closed.74793aa1.png";